import { authenticationService } from '../_services';

export function authHeader() {
    // return authorization header with jwt token
    const currentUser = authenticationService.currentUserValue;
    if (currentUser && currentUser.jwt_token) {
        //return { Authorization: `api-token: ${currentUser.jwt_token}` };
        return { "Content-Type": "application/json", "api-token": `${currentUser.jwt_token}` };
    } else {
        return {};
    }
}